export default __webpack_public_path__ + "static/media/login-icon2.f2c5ae8a.png";